module.exports = __webpack_public_path__ + "static/03-649f91784500f285a6ad920d199a9188.jpg";